import React, { useState } from "react";
import SoftTypography from "../SoftTypography";
import SoftBox from "../SoftBox";
import SoftButton from "../SoftButton";
import ResponsiveModal from "../ResponsiveModal";

const FILTER_OPTIONS = [
  {
    name: "Ranking",
  },
  {
    name: "Alphabetical",
  },
];

const Filter = ({ children, handleApply }) => {
  const [open, setOpen] = useState(false);
  const [filterIdx, setFilterIdx] = useState(0);

  const handleOpen = (event) => {
    if (!event.target.disabled) {
      setOpen(true);
    }
    event.stopPropagation();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleFilter = (idx) => {
    setFilterIdx(idx);
  };

  const handleSave = (index) => {
    setOpen(false);
    handleApply(index);
  };

  return (
    <>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          onClick: handleOpen,
        });
      })}
      <ResponsiveModal
        open={open}
        onClose={handleClose}
        title="Filter"
        subtitle="Choose how results are sorted."
        actions={
          <SoftButton
            variant="contained"
            color="primary"
            onClick={() => handleSave(filterIdx)}
            sx={{ width: "100%", textTransform: "none", borderRadius: "8px" }}
          >
            Apply filter
          </SoftButton>
        }
      >
        <SoftBox
          role="tablist"
          sx={{
            display: "flex",
            background: "#F2F4F7",
            borderRadius: "10px",
            padding: "4px",
            gap: "4px",
          }}
        >
          {FILTER_OPTIONS.map((type, index) => {
            const selected = filterIdx === index;
            return (
              <SoftButton
                key={`filter-${type.name}`}
                role="tab"
                aria-selected={selected}
                onClick={() => handleFilter(index)}
                sx={{
                  flex: 1,
                  background: selected ? "#fff" : "transparent",
                  border: selected ? "1px solid var(--gmb-primary, #1B598E)" : "1px solid transparent",
                  boxShadow: selected ? "0px 1px 2px rgba(16, 24, 40, 0.08)" : "none",
                  borderRadius: "8px",
                  padding: "10px 12px",
                  textTransform: "none",
                  "&:hover": {
                    background: selected ? "#fff" : "rgba(16, 24, 40, 0.04)",
                    boxShadow: selected ? "0px 1px 2px rgba(16, 24, 40, 0.08)" : "none",
                  },
                }}
              >
                <SoftTypography
                  sx={{
                    fontSize: "14px!important",
                    fontWeight: selected ? "700!important" : "600!important",
                    color: selected ? "#101828" : "#667085",
                  }}
                >
                  {type.name}
                </SoftTypography>
              </SoftButton>
            );
          })}
        </SoftBox>
      </ResponsiveModal>
    </>
  );
};

export default Filter;
